import React, { useEffect, useState } from 'react';
// import Select from 'react-select';
import { withRouter } from 'react-router-dom';
import { customStyle, numberFormat } from 'helper';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import _ from 'lodash';

function PaymentComponent({
  value,
  onChange,
  yearOptions,
  quarters,
  actualUseList,
  applicationInfo,
  getQuarter,
}) {
  const [items, setItem] = useState({
    item: [],
  });

  useEffect(() => {
    setItem({
      item: value || [],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.length]);

  const updateProps = (newItem) => {
    onChange(_.get(newItem, 'item'));
  };

  const qtrOptions = (item) => {
    if (
      _.get(
        applicationInfo,
        'attributes.effectivity_of_assessment_reassessment_yr'
      ) === _.get(item, 'year')
    ) {
      return getQuarter(
        _.get(
          applicationInfo,
          'attributes.effectivity_of_assessment_reassessment_qtr'
        )
      );
    }
    return quarters;
  };

  const handleChangeInput = (item, key, amount) => {
    const newItem = {
      item: (items.item || []).map((x) =>
        x.id === item.id ? { ...x, [key]: `${amount}` } : x
      ),
    };
    setItem(newItem);
    updateProps(newItem);

    if (!amount) {
      const newerItem = {
        item: (items.item || []).map((x) =>
          x.id === item.id ? { ...x, [key]: '' } : x
        ),
      };
      setItem(newerItem);
      updateProps(newerItem);
    }
  };

  const handleOnChangeSelect = (item, key) => (e) => {
    const newItem = {
      item: (items.item || []).map((x) =>
        x.id === item.id ? { ...x, [key]: e.value } : x
      ),
    };
    setItem(newItem);
    updateProps(newItem);
  };

  const handleAddItem = () => {
    setItem({
      item: (items.item || []).concat([
        {
          id: (_.get(items, `item.${items.item.length - 1}.id`) || 0) + 1,
          basic_amount: 0,
          basic_penalty: 0,
          basic_discount: 0,
          sef_amount: 0,
          sef_penalty: 0,
          sef_discount: 0,
        },
      ]),
    });
  };

  const handleRemoveItem = (item) => () => {
    const newItem = {
      item: (items.item || []).filter((x) => x.id !== item.id),
    };
    setItem(newItem);
    updateProps(newItem);
  };

  const createDropDown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
      });
    });
    return newList;
  };

  const onBlurDecimal =
    (item, key) =>
    ({ target }) => {
      const newItem = {
        item: (items.item || []).map((x) =>
          x.id === item.id
            ? {
                ...x,
                [key]: target.value ? target.value.replace(/[,]/g, '') : '',
              }
            : x
        ),
      };
      setItem(newItem);
      updateProps(newItem);
    };

  const onChangeDecimal = (item, key, amount) => {
    const newItem = {
      item: (items.item || []).map((x) =>
        x.id === item.id
          ? {
              ...x,
              [key]: parseFloat(amount) ? parseFloat(amount) : 0,
            }
          : x
      ),
    };
    setItem(newItem);
    updateProps(newItem);
  };

  return (
    <>
      {(items.item || []).map((item, i) => (
        <>
          <div className="col-12 form-group row" key={+item.id}>
            <div className="col-6 form-group">
              <label className="form-label">
                Actual Use ID:
                <span className="text-danger">
                  {' '}
                  <i>Required</i>{' '}
                </span>
              </label>
              <div>
                <Select
                  options={createDropDown(actualUseList)}
                  styles={customStyle}
                  placeholder="Select Actual Use"
                  value={
                    createDropDown(actualUseList).filter(
                      (data) =>
                        +_.get(item, 'actual_use_id') === +_.get(data, 'value')
                    ) || ''
                  }
                  onChange={handleOnChangeSelect(item, 'actual_use_id')}
                />
              </div>
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label">
                Assessed Value:
              </label>
              <NumberFormat
                name="assessed_value"
                id="assessed_value"
                placeholder="0"
                className="form-control"
                onValueChange={(values) => {
                  const { floatValue } = values;
                  handleChangeInput(item, 'assessed_value', floatValue);
                }}
                onBlur={(values) => {
                  const { floatValue } = values;
                  onBlurDecimal(item, 'assessed_value', floatValue);
                }}
                value={_.get(item, 'assessed_value') || ''}
                isNumericString
                thousandSeparator
                allowNegativ
                allowLeadingZeros
                displayType="input"
                prefix=""
              />
            </div>
            <div className="form-group col-6">
              <label htmlFor="last_name" className="form-label">
                Year:
                <span className="text-danger">
                  {' '}
                  <i>Required</i>{' '}
                </span>
              </label>
              <Select
                options={yearOptions}
                styles={customStyle}
                placeholder="Select Year"
                value={yearOptions.find((x) => x.value === _.get(item, 'year'))}
                onChange={handleOnChangeSelect(item, 'year')}
              />
            </div>
            <div className="form-group col-6" />
            <div className="form-group col-6">
              <label htmlFor="last_name" className="form-label">
                Quarter From:
                <span className="text-danger">
                  {' '}
                  <i>Required</i>{' '}
                </span>
              </label>
              <Select
                options={qtrOptions(item)}
                styles={customStyle}
                placeholder="Select Quarter"
                value={qtrOptions(item).find(
                  (x) => x.value === _.get(item, 'qtr_from')
                )}
                onChange={handleOnChangeSelect(item, 'qtr_from')}
              />
            </div>
            <div className="form-group col-6">
              <label htmlFor="last_name" className="form-label">
                Quarter To:
                <span className="text-danger">
                  {' '}
                  <i>Required</i>{' '}
                </span>
              </label>
              <Select
                options={qtrOptions(item)}
                styles={customStyle}
                placeholder="Select Quarter"
                value={qtrOptions(item).find(
                  (x) => x.value === _.get(item, 'qtr_to')
                )}
                onChange={handleOnChangeSelect(item, 'qtr_to')}
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label">
                Basic Amount:
              </label>
              <NumberFormat
                name="basic_amount"
                id="basic_amount"
                placeholder="0"
                className="form-control"
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChangeDecimal(item, 'basic_amount', floatValue);
                }}
                onBlur={(values) => {
                  const { floatValue } = values;
                  onBlurDecimal(item, 'basic_amount', floatValue);
                }}
                value={_.get(item, 'basic_amount') || ''}
                isNumericString
                thousandSeparator
                allowNegativ
                allowLeadingZeros
                displayType="input"
                prefix=""
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label">
                Basic Penalty:
              </label>
              <NumberFormat
                name="basic_penalty"
                id="basic_penalty"
                placeholder="0"
                className="form-control"
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChangeDecimal(item, 'basic_penalty', floatValue);
                }}
                onBlur={(values) => {
                  const { floatValue } = values;
                  onBlurDecimal(item, 'basic_penalty', floatValue);
                }}
                value={_.get(item, 'basic_penalty') || ''}
                isNumericString
                thousandSeparator
                allowNegativ
                allowLeadingZeros
                displayType="input"
                prefix=""
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label">
                Basic Discount:
              </label>
              <NumberFormat
                name="basic_discount"
                id="basic_discount"
                placeholder="0"
                className="form-control"
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChangeDecimal(item, 'basic_discount', floatValue);
                }}
                onBlur={(values) => {
                  const { floatValue } = values;
                  onBlurDecimal(item, 'basic_discount', floatValue);
                }}
                value={_.get(item, 'basic_discount') || ''}
                isNumericString
                thousandSeparator
                allowNegativ
                allowLeadingZeros
                displayType="input"
                prefix=""
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label">
                SEF Amount:
              </label>
              <NumberFormat
                name="sef_amount"
                id="sef_amount"
                placeholder="0"
                className="form-control"
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChangeDecimal(item, 'sef_amount', floatValue);
                }}
                onBlur={(values) => {
                  const { floatValue } = values;
                  onBlurDecimal(item, 'sef_amount', floatValue);
                }}
                value={_.get(item, 'sef_amount') || ''}
                isNumericString
                thousandSeparator
                allowNegativ
                allowLeadingZeros
                displayType="input"
                prefix=""
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label">
                SEF Penalty:
              </label>
              <NumberFormat
                name="sef_penalty"
                id="sef_penalty"
                placeholder="0"
                className="form-control"
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChangeDecimal(item, 'sef_penalty', floatValue);
                }}
                onBlur={(values) => {
                  const { floatValue } = values;
                  onBlurDecimal(item, 'sef_penalty', floatValue);
                }}
                value={_.get(item, 'sef_penalty') || ''}
                isNumericString
                thousandSeparator
                allowNegativ
                allowLeadingZeros
                displayType="input"
                prefix=""
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label">
                SEF Discount:
              </label>
              <NumberFormat
                name="sef_discount"
                id="sef_discount"
                placeholder="0"
                className="form-control"
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChangeDecimal(item, 'sef_discount', floatValue);
                }}
                onBlur={(values) => {
                  const { floatValue } = values;
                  onBlurDecimal(item, 'sef_discount', floatValue);
                }}
                value={_.get(item, 'sef_discount') || ''}
                isNumericString
                thousandSeparator
                allowNegativ
                allowLeadingZeros
                displayType="input"
                prefix=""
              />
            </div>
            <div className="col-12 align-items-center justify-content-center d-flex">
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleRemoveItem(item)}
              >
                Delete
              </button>
            </div>
          </div>
        </>
      ))}
      <div className="px-3 table-modal">
        <span className="font-weight-bold">
          {' '}
          Total Amount: PHP{' '}
          {numberFormat(
            _.reduce(
              items.item,
              (total, b) =>
                b.basic_amount +
                b.sef_amount +
                b.basic_penalty +
                b.sef_penalty -
                (b.basic_discount + b.sef_discount) +
                total,
              0
            ),
            2
          )}
        </span>
        <div className="mt-2">
          <button
            type="button"
            onClick={handleAddItem}
            className="btn button-add-another"
          >
            <i className="fas fa-plus" /> &nbsp; Add Payment
          </button>
        </div>
      </div>
    </>
  );
}

PaymentComponent.defaultProps = {};

PaymentComponent.propTypes = {
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.instanceOf(Array).isRequired,
  yearOptions: PropTypes.instanceOf(Array).isRequired,
  quarters: PropTypes.instanceOf(Array).isRequired,
  actualUseList: PropTypes.instanceOf(Array).isRequired,
  getQuarter: PropTypes.instanceOf(Function).isRequired,
  applicationInfo: PropTypes.instanceOf(Object).isRequired,
};

const enhance = _.flowRight([withRouter]);

export default enhance(PaymentComponent);
